<template>
  <td>
    {{ rowData.reserveTime.slice(0, 5) }}
    <ToolTip v-if="rowData.duplicated">
      [!]
      <template #content>
        <dd class="cont">
          받는사람과 전송주기, 예약시간이 동일한 소식이 있는지 확인해 주세요.
          <br />2개 이상의 소식이 동시에 전송되면 <br />시간상 마지막에 도달한 1개 소식만 들을 수 있습니다.
        </dd>
      </template>
    </ToolTip>
  </td>
</template>

<script>
export default {
  props: {
    rowData: Object,
  },
};
</script>

<style></style>
